module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "parts-catalog-list-count"
  }, [(_vm.hasText) ? _c('div', {
    staticClass: "parts-catalog-list-count__text"
  }, [_vm._v(_vm._s(_vm.text))]) : _vm._e(), _c('FormSelect', {
    attrs: {
      "name": _vm.name,
      "options": _vm.options,
      "placeholder": _vm.placeholder,
      "value": _vm.value
    },
    on: {
      "input": _vm.onInput
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f4def69a","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/catalog/list/count/component.vue
// module id = 8396f72279c93e8bf9d5
// module chunks = 0